"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
class TaskDto {
}
exports.TaskDto = TaskDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], TaskDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Task name" }),
    tslib_1.__metadata("design:type", String)
], TaskDto.prototype, "taskName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], TaskDto.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 434 }),
    tslib_1.__metadata("design:type", Number)
], TaskDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 536 }),
    tslib_1.__metadata("design:type", Number)
], TaskDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], TaskDto.prototype, "assigneeId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2025-06-20" }),
    tslib_1.__metadata("design:type", String)
], TaskDto.prototype, "dueDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 53 }),
    tslib_1.__metadata("design:type", Number)
], TaskDto.prototype, "priorityLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Task description" }),
    tslib_1.__metadata("design:type", String)
], TaskDto.prototype, "description", void 0);
